import { forwardRef } from "react";

interface PathProps {
  stroke: string;
  strokeWidth: string;
  opacity?: string;
  filter?: string;
}

const Path = forwardRef<SVGPathElement, PathProps>(
  ({ stroke, strokeWidth, opacity, filter }: PathProps, ref) => (
    <path
      ref={ref}
      d="M0 2C244.55 2 486.084 15.9504 684 42C936.499 75.2339 1118.71 128.966 1147 203C1149.55 209.655 1151.35 217.122 1151.35 224.1C1151.35 286.978 988.953 332.618 796 379C617.196 421.975 411.577 465.884 286 525C213.989 558.894 168.578 597.58 168.578 644.325C168.578 689.926 210.71 725.579 276 756C404.066 815.678 465 807.5 779 901C1093 994.5 1413.5 1229.5 1103 1542.5"
      stroke={stroke}
      strokeWidth={strokeWidth}
      opacity={opacity}
      filter={filter}
    />
  ),
);

Path.displayName = "Path";
export { Path };
